import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import MatchedIcon from "../Assets/Icons/matchedIcon.svg";

export default function NotificationSettingModal({ open, setOpen }) {
  const cancelButtonRef = useRef(null);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-[42rem] sm:max-w-lg">
                <div className="bg-white px-3 pb-4 pt-4 sm:px-4 sm:p-3 sm:pb-4">
                  <div className="sm:flex sm:items-start sm:flex-col">
                    <div>
                      <p className="text-[1.2rem] text-[#111928] font-[700]">
                        Notifications
                      </p>
                      <p className="text-[1rem] text-[#6B7280] mt-2">
                        For important updates regarding your activity, certain
                        notification cannot be disabled
                      </p>
                    </div>
                    <div className="w-full h-[2.3rem] px-3 bg-[#F9FAFB] flex items-center justify-between mt-6">
                      <p className="text-[0.80rem] text-[#6B7280]">Туре</p>
                      <div className="flex items-center gap-4">
                        <p className="text-[0.80rem] text-[#6B7280]">Email</p>
                        <p className="text-[0.80rem] text-[#6B7280]">Web</p>
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center gap-[265px] mt-3">
                        <p className="text-[0.94rem] text-[#6B7280]">
                          Platform Updates
                        </p>
                        <div className="flex items-center gap-4">
                          <label className="relative inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              defaultValue
                              className="sr-only peer"
                            />
                            <div className="w-[2.1rem] h-[1.25rem] bg-[#E5E7EB] peer-focus:outline-none rounded-full peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[-4px] after:bg-white after:rounded-full after:h-[1rem] after:ml-[5px] after:w-[1rem] after:transition-all peer-checked:bg-[#942A27]" />
                          </label>
                          <label className="relative inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              defaultValue
                              className="sr-only peer"
                            />
                            <div className="w-[2.1rem] h-[1.25rem] bg-[#E5E7EB] peer-focus:outline-none rounded-full peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[-4px] after:bg-white after:rounded-full after:h-[1rem] after:ml-[5px] after:w-[1rem] after:transition-all peer-checked:bg-[#942A27]" />
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
